import { render, staticRenderFns } from "./HowItWorksMore.vue?vue&type=template&id=60c6c2e1"
import script from "./HowItWorksMore.vue?vue&type=script&lang=js"
export * from "./HowItWorksMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports